import { PlanConsumerType } from "../enums";
import { PlanConsumerTypesLabels } from "../labels";

export const getPlanConsumerTypes = () => [
  {
    id: PlanConsumerType.User,
    name: PlanConsumerTypesLabels[PlanConsumerType.User],
  },
  {
    id: PlanConsumerType.Family,
    name: PlanConsumerTypesLabels[PlanConsumerType.Family],
  },
];

export const humanizeConsumerType = (consumerType?: PlanConsumerType) => {
  return consumerType
    ? getPlanConsumerTypes().find((x) => x.id === consumerType)?.name
    : "";
};
